export enum BasicServicesEnum {
  HeatingAndCooling = 'heating_and_cooling',
  DrinkingWaterInstallation = 'drinking_water_installation',
  Sewage = 'sewage',
  FloorHeating = 'floor_heating',
}
